module.exports = __webpack_public_path__ + "media/images/timbres_honorarios_bg-1e8c1b56.png";